import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { UiKit } from 'components';

/**
 * @param {React.InputHTMLAttributes<HTMLLabelElement> & {
 *  htmlFor?: string,
 *  text?: string,
 *  tooltipText?: string,
 *  weight?: import('utils/types').Weight,
 *  forceMount?: boolean,
 *  className?: string,
 *  children?: React.ReactNode,
 *  ...htmlLabelProps?: React.InputHTMLAttributes<HTMLLabelElement>
 * }} props
 */
export default function Label({
  htmlFor,
  text = '',
  tooltipText = '',
  weight = 'bold',
  forceMount = false,
  className = '',
  children = null,
  ...htmlLabelProps
}) {
  if (!forceMount && !text) return children;

  return (
    <label
      htmlFor={htmlFor}
      className={cn(styles.container, className)}
      {...htmlLabelProps}
    >
      <UiKit.Title size="sm" weight={weight} tooltipText={tooltipText}>
        {text}
      </UiKit.Title>
      {children}
    </label>
  );
}
